/**
 * @flow
 * @relayHash 9b4d3e45f52aeeb6ec24a43fc077f25b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMpTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type Notes_UpdateMpTemplateMutationVariables = {|
  input: UpdateMpTemplateInput
|};
export type Notes_UpdateMpTemplateMutationResponse = {|
  +updateMpTemplate: ?{|
    +mp_template: ?{|
      +id: string,
      +notes: ?string,
    |}
  |}
|};
export type Notes_UpdateMpTemplateMutation = {|
  variables: Notes_UpdateMpTemplateMutationVariables,
  response: Notes_UpdateMpTemplateMutationResponse,
|};
*/


/*
mutation Notes_UpdateMpTemplateMutation(
  $input: UpdateMpTemplateInput!
) {
  updateMpTemplate(input: $input) {
    mp_template {
      id
      notes
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMpTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateMpTemplateInput!"
      }
    ],
    "concreteType": "UpdateMpTemplatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mp_template",
        "storageKey": null,
        "args": null,
        "concreteType": "MpTemplate",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Notes_UpdateMpTemplateMutation",
  "id": null,
  "text": "mutation Notes_UpdateMpTemplateMutation(\n  $input: UpdateMpTemplateInput!\n) {\n  updateMpTemplate(input: $input) {\n    mp_template {\n      id\n      notes\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Notes_UpdateMpTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Notes_UpdateMpTemplateMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fdf0b497958d0bccdcdf8f7e8fe8c5a4';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/__generated__/Notes_UpdateMpTemplateMutation.graphql.js